// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class LocationVm {
    @AutoMap() lctId: string;
    @AutoMap() lctName: string;
    @AutoMap() lctIcon?: any;
    @AutoMap() locationDetail?: any;
}
